import styled from "styled-components";
import { CheckStyle } from "../../../../styles/components/check";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  position: relative;

  margin-top: 10px;
`;

export const SelectButton = styled.div`
  width: 100%;
  height: 58px;
  padding: 13px;
  margin-bottom: 0px !important;

  border-radius: ${theme.border.smallRadius};
  border: 1px solid #b9c1cb;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  background: ${theme.colors.white};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.black};
  cursor: pointer;

  display: flex;
  justify-content: space-between;
  align-items: center;

  & > svg > path {
    fill: ${theme.colors.black};
  }

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #c4c4c4;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #c4c4c4;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #c4c4c4;
  }
`;

export const Options = styled.div`
  padding: 15px;
  width: 100%;
  max-height: 250px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  border: 1px solid ${theme.colors.gray200};
  border-radius: ${theme.border.smallRadius};
  background: ${theme.colors.white};

  position: absolute;
  top: 50px;
  z-index: 99;
  overflow-y: auto;
  overflow-x: hidden;

  & > div {
    display: inline-flex;

    & > span {
      margin-left: 10px;

      font-size: ${theme.font.sizes.small};
      font-family: ${theme.font.workSans};
      font-weight: ${theme.font.normal};
      color: ${theme.colors.black};
    }
  }
`;

export const Input = styled.input`
  ${CheckStyle}
`;

export const SearchInput = styled.input`
  width: 90%;

  border: none;
`;
